<!--  -->
<template>
  <div class="main">
    <a-row style="margin-bottom: 0">
      <a-col :span="9">
        <ul class="drag-matic">
          <li v-for="item in maticList" :key="item.type">
            <div :title="item.title" @click="addList(item)">
              <img :src="item.pic" alt="" />
            </div>
          </li>
        </ul>
      </a-col>
      <a-col :span="1"> </a-col>
      <a-col :span="14">
        <div class="matic-template">
          <div style="text-align: center; margin-top: 20px">
            <a-input
              placeholder="模板名称"
              style="width: 450px"
              :maxLength="20"
              @change="inputChage"
              :value="inputValue"
            />
          </div>
          <div>
            <draggable
              v-model="lists"
              group="people"
              animation="300"
              @start="onStart"
              @end="onEnd"
            >
              <div
                v-for="(item, index) in lists"
                :key="index"
                class="list-title"
              >
                <img :src="item.pic" alt="" />
                <div class="list-button" v-if="item.cate === 0">
                  <a-button size="small" type="primary" @click="addCate(index)"
                    >添加栏目</a-button
                  >
                </div>
                <div class="list-button" v-else>
                  <a-tag
                    color="#108ee9"
                    @click="addCate(index)"
                    style="cursor:pointer;"
                  >
                    {{ item.catname }}
                  </a-tag>
                </div>
                <div class="icon" @click="del(index)"></div>
              </div>
            </draggable>
          </div>
        </div>
      </a-col>
    </a-row>
    <footer-tool-bar>
      <a-button @click="addDrag">保存模板</a-button>
    </footer-tool-bar>
    <a-modal
      title="选择栏目"
      :visible="visible"
      width="400px"
      :bodyStyle="{ padding: 0 }"
      @cancel="visible = false"
      @ok="choose"
      :zIndex="1001"
    >
      <div class="modal-cate">
        <a-select
          style="width: 200px"
          class="modal-select"
          :value="modelSelect"
          @change="handleChange"
          show-search
          :filterOption="filterOption"
        >
          <a-select-option v-for="item in cateList" :key="item.catid">
            {{ item.catname }}
          </a-select-option>
        </a-select>
      </div>
    </a-modal>
  </div>
</template>

<script>
import draggable from 'vuedraggable';
import FooterToolBar from '../../components/FooterToolBar';
export default {
  components: { draggable, FooterToolBar },
  data() {
    return {
      drag: false,
      param: { page: 1, limit: 999 },
      maticList: [],
      lists: [],
      cateList: [],
      visible: false,
      modelSelect: '',
      cataIndex: '',
      inputValue: '',
      specid: 0
    };
  },
  methods: {
    onStart(e) {
      this.drag = true;
    },
    //拖拽结束事件
    onEnd(e) {
      this.drag = false;
    },
    addList(item) {
      let copy = { ...item };
      copy.cate = 0;
      this.lists.push(copy);
    },
    del(i) {
      this.lists.splice(i, 1);
    },
    getPicList(param) {
      this.$http
        .post('http://127.0.0.1:8360/api/special/picList', param)
        .then(res => {
          if (res.data.errno === 0) {
            this.maticList = res.data.data.lists;
          }
        });
    },
    getCateList() {
      this.$http
        .post('/api/content/categorylist', { limit: 9999 })
        .then(res => {
          if (res.data.state == 200) {
            this.cateList = res.data.data;
          }
        });
    },
    handleChange(value) {
      this.modelSelect = value;
    },
    addCate(index) {
      this.visible = true;
      this.cataIndex = index;
      this.modelSelect = '';
    },
    choose() {
      this.lists[this.cataIndex].cate = this.modelSelect;
      this.cateList.forEach(item => {
        if (item.catid == this.modelSelect) {
          this.lists[this.cataIndex].catname = item.catname;
        }
      });
      this.visible = false;
      this.$message.success('选择成功');
    },
    inputChage(e) {
      this.inputValue = e.target.value;
    },
    addDrag() {
      if (this.lists.length === 0) {
        this.$message.error('模板不能为空');
        return false;
      } else if (this.inputValue === '') {
        this.$message.error('模板标题不能为空');
        return false;
      }
      let dragLsit = [];
      this.lists.forEach(item => {
        dragLsit.push({
          cate: item.cate,
          pic: item.pic,
          title: item.title,
          catname: item.catname
        });
      });
      let param = {
        catname: this.inputValue,
        template: JSON.stringify(dragLsit)
      };
      if (this.specid !== 0) {
        param.specid = this.specid;
      }
      this.$http
        .post('http://127.0.0.1:8360/api/special/updateCate', param)
        .then(res => {
          if (res.data.errno == 0) {
            this.$message.success('成功');
          }
        });
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    getCate(specid) {
      //获取模板详情
      this.$http
        .post('http://127.0.0.1:8360/api/special/getCate', {
          specid
        })
        .then(res => {
          if (res.data.errno === 0) {
            let info = res.data.data.info;
            this.inputValue = info.catname;
            let template = JSON.parse(info.template);
            this.lists = template;
          }
        });
    }
  },
  created() {
    this.getPicList(this.param);
    this.getCateList();
    if (this.$route.query.specid) {
      this.specid = this.$route.query.specid;
      this.getCate(this.specid);
    }
  }
};
</script>
<style scoped>
.main {
  position: absolute;
  top: 60px;
  left: 20px;
  right: 20px;
  bottom: 20px;
  overflow-y: auto;
  padding: 20px;
  background-color: #fff;
}
.list-title {
  width: 100%;
  height: 190px;
  text-align: center;
  position: relative;
}
.list-title img {
  width: 90%;
  height: 100%;
}
.drag-matic {
  display: flex;
  width: 100%;
  flex-wrap: wrap;
}
.drag-matic li {
  padding: 10px 5px;
}
.drag-matic li div {
  width: 95%;
  padding: 10px 0;
  margin: 0 auto;
  text-align: center;
  border: 1px dashed #dedede;
  border-radius: 3px;
  cursor: pointer;
}
.drag-matic li div:hover {
  border-color: #49b2ff;
}
.matic-template {
  min-height: 600px;
  border: 1px solid #ddd;
}
.icon {
  position: absolute;
  top: 26px;
  font-size: 24px;
  left: 87%;
  width: 35px;
  height: 30px;
  background-image: url('../../assets/matic/del.png');
  cursor: pointer;
}
.list-button {
  position: absolute;
  top: 28px;
  left: 10.5%;
}
.modal-cate {
  height: 140px;
  width: 100%;
  text-align: center;
  line-height: 120px;
}

@media screen and (max-width: 1499px) {
  .drag-matic li {
    width: 100%;
  }
}
@media screen and (min-width: 1500px) {
  .drag-matic li {
    width: 100%;
  }
}
</style>
